import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { ContactService } from '@app/services/contact.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OrderCheckoutRouteGuard  {
    constructor(private auth: AuthService, private contactService: ContactService, private router: Router) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this.auth.isAuthenticated()) {
            return true;
        }

        const config$ = this.contactService.getOrganisationConfig(AuthService.getAccessToken());
        return config$.pipe(
            map((config) => {
                if (config.canOrderSamplingSupplies || config.canOrderLabTests) {
                    return true;
                } else {
                    setTimeout(() => {
                        this.router.navigateByUrl('/');
                    }, 200);

                    return false;
                }
            })
        );
    }
}
